<template>
  <div id="regLab">
    <div class="main">
      <h2>{{$t('cmsg.regLabTitle')}}</h2>
      <div class="login_panel">
      <el-row :gutter="15">
        <el-col :span="16">
            <el-form
              ref="regLabForm"
              :model="form.field"
              status-icon
              :validate-on-rule-change="false"
              :label-width="$gf.lang() === 'en'?'120px':'80px'"
              :show-message="false"
            >
              <el-form-item required prop="name" :label="$t('cmsg.name')"
                      :error="form.errors.Name">
                <el-input v-model="form.field.name" @keyup.enter.native="onSubmit"></el-input>
              </el-form-item>
              <el-form-item required prop="addr" :label="$t('cmsg.addr')"
                      :error="form.errors.Addr">
                <el-input v-model="form.field.addr" @keyup.enter.native="onSubmit"></el-input>
              </el-form-item>
              <el-form-item required prop="captcha" :label="$t('cmsg.captcha')"
                      :error="form.errors.Captcha">
                <el-input v-model="form.field.captcha" @keyup.enter.native="onSubmit">
                  <el-button slot="prepend" class="captcha_img" @click="new_captcha">
                    <img :src="form.captcha_img" v-if="form.captcha_img">
                  </el-button>
                </el-input>
              </el-form-item>
              <el-card class="set_default_admin_panel" shadow="never">
                <div slot="header" class="clearfix">
                  <span>{{$t('cmsg.set1DefaultAdmin')}}:</span>
                </div>
                <el-form-item required prop="nickName" :label="$t('cmsg.contact')"
                      :error="form.errors.NickName">
                  <el-input v-model="form.field.nickName" @keyup.enter.native="onSubmit"></el-input>
                </el-form-item>

                <el-row>
                  <el-col :span="8">
                    <el-form-item
                      required
                      prop="phoneArea"
                      :label="$t('cmsg.mobile')"
                      :error="form.errors.PhoneArea"
                      :rules="[
        {required: true,message:$t('cmsg.required')},
        {type: 'number',message:$t('cmsg.integerRequired')}
        ]"
                    >
                      <el-select
                        v-model="form.field.phoneArea"
                        v-model.number="form.field.phoneArea"
                        filterable
                        :placeholder="$t('cmsg.countryCode')"
                      >
                        <el-option
                          v-for="i in $countryCodes"
                          :label="i.label"
                          :value="i.value"
                          :key="i.label"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="16">
                    <el-form-item
                      required
                      prop="phone"
                      label-width="0px"
                      :error="form.errors.Username"
                      :rules="[
        {required: true,message:$t('cmsg.required')},
        {type: 'number',message:$t('cmsg.integerRequired')}
        ]"
                    >
                      <el-input
                        v-model="form.field.phone"
                        v-model.number="form.field.phone"
                        :placeholder="$t('cmsg.mobile')"
                        @keyup.enter.native="onSubmit"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item required prop="email" :label="$t('cmsg.email')"
                      :error="form.errors.Email">
                  <el-input type="email" v-model="form.field.email" @keyup.enter.native="onSubmit"></el-input>
                </el-form-item>
                <el-form-item required prop="password" :label="$t('cmsg.password')"
                      :error="form.errors.Password">
                  <el-input
                    type="password"
                    v-model="form.field.password"
                    @keyup.enter.native="onSubmit"
                  ></el-input>
                </el-form-item>
                <el-form-item required prop="repassword" :label="$t('cmsg.passwordAgain')"
                      :error="form.errors.Password">
                  <el-input
                    type="password"
                    v-model="form.field.repassword"
                    @keyup.enter.native="onSubmit"
                  ></el-input>
                </el-form-item>
              </el-card>
              <el-form-item
              required
                label="Privacy"
                prop="privacy"
                v-if="$gf.lang()==='en'"
                :error="form.errors.Privacy"
                :rules="[
        {required: true,message:$t('cmsg.required')}
        ]"
              >
                <el-checkbox v-model="form.field.privacy"></el-checkbox>You must agree to our
                <el-button type="text" @click="privacyVisible = true">data protection policy</el-button>and check it out. Please read it carefully.
              </el-form-item>
              <el-dialog
                title="Privacy Policy"
                :visible.sync="privacyVisible"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                width="80%"
              >
                <privacyEnLib/>
              </el-dialog>
              <br>
              <!-- <p class="bg-danger" v-if="form.err">{{form.err}}</p> -->
              <el-form-item>
                <el-button
                  type="primary"
                  @click="onSubmit"
                  class="submit_btn"
                  :loading="form.loading"
                >{{$t('cmsg.applyNow')}}</el-button>
              </el-form-item>
              <p>
                {{$t('cmsg.orBackTo')}}
                <router-link :to="{name:'login'}">
                  <el-button type="text">{{$t('cmsg.login')}}</el-button>
                </router-link>
              </p>
            </el-form>
          </el-col>
          <el-col :span="8">
            <rightSide/>
          </el-col>
        </el-row>
      </div>
    </div>
    <bottomWrapper/>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import bottomWrapper from "@/views/component/bottom.vue";
import rightSide from "./component/rightSide.vue";
import privacyEnLib from "@/views/component/privacyEn.vue";
export default {
  components: {
    bottomWrapper,
    privacyEnLib,
    rightSide
  },
  metaInfo() {
    return {
      title: this.$gf.sysParam(this.$gf.lang(), 'title') + "-" + this.$t("cmsg.regLabTitle"),
      meta: [
        { vmid: "description", name: "description", content: "Shining3D Login" }
      ]
    };
  },
  data() {
    return {
      privacyVisible: false,
      form: {
        captcha_img: "",
        field: {
          captcha: "",
          uuid: "",
          name: "",
          addr: "",
          password: "",
          repassword: "",
          nickName: "",
          instituationType: "lab",
          email: "",
          phone: null,
          phoneArea: null
        },
        errors: {
          Captcha: null,
          Name: null,
          Addr: null,
          Password: null,
          NickName: null,
          Privacy: null,
          InstituationType: null,
          Email: null,
          Phone: null,
          PhoneArea: null
        },
        loading: false,
        err: ""
      }
    };
  },
  methods: {
    onSubmit() {
      this.form.err = "";
      // var vueObj = this;
      if (!this.form.field.privacy && this.$gf.lang() === "en") {
        console.log("check privacy!");
        // this.form.err = this.$t("cmsg.twoPwdMatch");
        this.form.errors["Privacy"] = "Please check the privacy out first.";
        this.$message({
          type: "error",
          message: "Please check the privacy out first."
        });
        return false;
      }
      if (this.form.field.password !== this.form.field.repassword) {
        this.form.err = this.$t("cmsg.twoPwdMatch");
        this.form.errors["Password"] = this.$t("cmsg.twoPwdMatch");
        this.$message({
          type: "error",
          message: this.$t("cmsg.twoPwdMatch")
        });
        return false;
      }
      this.form.field.phone = parseInt(this.form.field.phone);
      this.form.field.phoneArea = parseInt(this.form.field.phoneArea);
      this.$refs["regLabForm"].validate(valid => {
        if (valid) {
          // this.form.loading = false;
          this.form.loading = true;
          this.form.field.phone = this.form.field.phone.toString();
          this.form.field.phoneArea = this.form.field.phoneArea.toString();
          console.log(this.form.field);
          this.$axios
            .post(`/api/da/instituation`, this.form.field, {
              json: true,
              validateStatus: function(status) {
                return status >= 200 && status < 404; // default
              }
            })
            .then(res => {
              console.log("res: ", res);
              if (res.data && res.data.status === "success") {
                this.$message({
                  type: "success",
                  message: this.$t("cmsg.successAction")
                });
                var t = this;
                setTimeout(function() {
                  t.$redirect({ name: "login" });
                }, 3000);
              } else {
                this.form.field.phone = parseInt(this.form.field.phone);
                this.form.field.phoneArea = parseInt(this.form.field.phoneArea);
                if(res.data && res.data.result && res.data.result==="uExist") {
                  this.$message({
                  type: "error",
                  message: this.$t("cmsg.accountExist")
                });
                this.form.loading = false;
                return false;
                }
                var ermsg = {};
                var fs = [];
                try {
                  ermsg = JSON.parse(res.data.result);
                } catch (e) {
                  console.log(e);
                }
                Object.keys(ermsg).map((erk, i) => {
                  this.form.errors[erk] = this.$t("cmsg.errField");
                  fs.push(erk);
                });
                this.form.err = res.data.result;
                this.$message({
                  type: "error",
                  duration:0,
                  showClose:true,
                  message: fs.join(",")+this.$t("cmsg.errField")
                });
                this.form.loading = false;
              }
            })
            .catch(err => {
              console.log("err: ", err);
              this.form.err = this.$t("cmsg.mting");
              this.form.loading = false;
            });
        } else {
          this.form.loading = false;
          return false;
        }
      });
    },

    new_captcha() {
      this.$axios
        .get(
          `/api/captcha/${
            this.$gf.uuid()
          }?w=180&h=31&p=dental-apply-lab&e=86400`,
          {
            validateStatus: function(status) {
              return status >= 200 && status < 404; // default
            }
          }
        )
        .then(res => {
          if (
            res &&
            res.data &&
            res.data.result &&
            res.data.status === "success"
          ) {
            this.form.captcha_img = res.data.result;
          } else {
            this.form.captcha_img = "";
          }
        });
    }
  },
  mounted() {
    var tLang = Cookies.get("lang");
    if (tLang === "cn" || !tLang) {
      this.form.field.phoneArea = 86;
    }
    this.form.field.uuid = "dental-apply-lab-" + this.$gf.uuid();
    this.new_captcha();
    console.log("mounted:",pub.cdnUrl);
  }
};
</script>
<style lang="scss">
#regLab {
  .main {
    background-color: #f7f9fb;
    padding: 15px 0px;
    h2 {
      // min-width: 1200px;
      width: 65vw;
      @media only screen and (max-width: 1020px) {
        width: 95vw;
      }
      text-align: left;
      margin: 0 auto;
      border-bottom: 5px solid #4b91d1;
      margin-bottom: 15px;
      padding-bottom: 5px;
    }
    .login_panel {
      // min-width: 1200px;
      width: 65vw;
      @media only screen and (max-width: 1020px) {
        width: 95vw;
      }
      margin: 0 auto;
      .el-card__header {
        background-color: transparent;
      }
      .el-form-item {
        text-align: left;
        .submit_btn {
          width: 100%;
        }
      }
      .set_default_admin_panel {
        text-align: left;
        // border-width: 0;
        background-color: transparent;
      }
      p {
        text-align: left;
      }
    }
  }
}
</style>
